import React from "react";
import { withRouter } from "react-router-dom";
import Header from "../../Components/Header/header.component";

import { Form, FormGroup, Input } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faEnvelopeOpen,
  faMobile,
} from "@fortawesome/free-solid-svg-icons";

import Button from "../../Components/LogButton/Button";
import "./contactUs.styles.scss";
import Footer from "../../Components/Footer/footer.component";

const ContactUs = ({ title, history }) => {
  document.title = "Contact Us";
  return (
    <div className="ContactUs-Wrapper">
      <Header fromContact />
      <div className="ContactUs-container">
        <span style={H3Style}>GET IN TOUCH</span>
        <p style={Contents}>
          {" "}
          <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: 10 }} />
          Skyloft, Creaticity Mall, Shastrinagar Yerwada,
          <br /> Pune. 446001
        </p>
        <p style={Contents}>
          {" "}
          <FontAwesomeIcon icon={faEnvelopeOpen} style={{ marginRight: 10 }} />
          Knock@Theblockchainschool.Io
        </p>
        <p style={Contents}>
          {" "}
          <FontAwesomeIcon icon={faMobile} style={{ marginRight: 10 }} />
          +91 989 0088 989
        </p>
        <Form layout="inline" style={{ marginTop: 60 }}>
          <FormGroup className="Name-Input">
            <Input
              componentClass="input"
              rows={1}
              placeholder="Name"
              style={{ width: 200 }}
            />
          </FormGroup>

          <FormGroup className="Email-Input">
            <Input
              componentClass="input"
              rows={6}
              placeholder="Email"
              style={{ width: 200 }}
            />
          </FormGroup>
          <br />
          <FormGroup className="Feedback-Input">
            <Input
              componentClass="textarea"
              rows={6}
              placeholder="Write Your Message Here"
              style={{ minWidth: "22vw" }}
            />
          </FormGroup>
          <br />
          <Button>Submit</Button>
          <Button
            onClick={function () {
              history.goBack();
            }}
          >
            Cancel
          </Button>
        </Form>
      </div>
      <Footer />
    </div>
  );
};

const H3Style = {
  fontSize: "calc(20px + 0.5vw)",
};

const Contents = {
  lineHeight: "200%",
  textAlign: "start",
  fontSize: "calc(12px + 0.2vw)",
  marginTop: "20px",
};

export default withRouter(ContactUs);
